export function pickSlug(raw: Record<string, string>, fallback?: string) {
  const s =
    raw['slug'] || raw['event_slug'] || raw['e_slug'] || raw['digitalProductId']
  return (s || fallback || '').trim() || undefined
}

export function pickPartnerId(raw: Record<string, string>) {
  const p = raw['partner'] || raw['partner_id'] || raw['p']
  return (p || '').trim() || undefined
}

export function pickEmail(raw: Record<string, string>) {
  const e = raw['email'] || raw['e']
  if (!e) return undefined
  try {
    if (/^[A-Za-z0-9+/]+=*$/.test(e) && e.length % 4 === 0) {
      return atob(e)
    }
  } catch {}
  try {
    return decodeURIComponent(e)
  } catch {
    return e
  }
}
